import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const Section = ({ img, children, reverse }) => (
  <section className={`w-full flex flex-col md:flex-row ${reverse ? 'md:flex-row-reverse' : ''} items-center justify-center mb-24 gap-0 md:gap-8`}>
    <img
      src={img}
      alt="Brutal65 V2"
      className="w-full md:w-[70vw] h-[40vh] md:h-[60vh] object-cover rounded-xl shadow-xl"
      style={{ maxWidth: '1200px' }}
    />
    <div className="md:w-[30vw] w-full px-8 md:px-16 flex flex-col items-center md:items-start mt-6 md:mt-0">
      <p className="text-gray-200 text-lg text-center md:text-left max-w-md">{children}</p>
    </div>
  </section>
);

const Brutal65V2 = () => (
  <ArticleWrapper articleId="brutal65_v2">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      {/* Full-screen hero image */}
      <div className="w-full h-[60vh] md:h-[80vh] relative flex items-center justify-center mb-16">
        <img
          src="/pictures/gallery/gallery14.JPG"
          alt="Brutal65 V2 Hero"
          className="absolute inset-0 w-full h-full object-cover object-center z-0"
          style={{ filter: 'brightness(0.7)' }}
        />
        <h1 className="relative z-10 text-4xl md:text-6xl font-bold text-white drop-shadow-lg text-center">Brutal65 V2</h1>
      </div>
      {/* Modular wide photo-comment sections */}
      <Section img="/pictures/gallery/gallery14.JPG">
        The Brutal65 V2 is a 65% custom keyboard with a clean, industrial look. Solid, no-nonsense, and built to last.
      </Section>
      <Section img="/pictures/gallery/gallery3.JPG" reverse>
        Full aluminum case. Hefty, premium, and zero flex. Feels like a tank.
      </Section>
      <Section img="/pictures/gallery/gallery5.JPG">
        Stiff typing feel, but satisfying. Gasket mount helps with acoustics. Minimal ping, deep sound.
        <audio controls className="w-full mt-4">
          <source src="/audio/brutal_milkyyellow_pcfoam.mp3" type="audio/mp3" />
          Your browser does not support the audio element.
        </audio>
      </Section>
      <Section img="/pictures/gallery/gallery6.JPG" reverse>
        65% layout, gasket mount, south-facing RGB, QMK/VIA, and multiple colorways. Simple, functional, and modern.
      </Section>
      {/* Video section, full width */}
      <div className="w-full flex flex-col items-center justify-center mb-24">
        <h2 className="text-2xl font-bold text-white mb-4 text-center">Video Review</h2>
        <div className="w-full flex justify-center">
          <iframe
            width="900"
            height="506"
            src="https://www.youtube.com/embed/your_video_id"
            title="Brutal65 V2 Sound Test"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="rounded-xl shadow-xl mx-auto w-full max-w-4xl"
          ></iframe>
        </div>
      </div>
      {/* Links section as styled buttons */}
      <div className="w-full flex flex-col items-center mb-24">
        <h2 className="text-2xl font-bold text-white mb-8 text-center">Explore More</h2>
        <div className="flex flex-col md:flex-row gap-4 items-center">
          <a
            href="/gallery"
            className="px-6 py-3 rounded-lg bg-black/70 border border-gray-700 text-gray-200 font-semibold shadow hover:bg-gray-800 hover:text-white transition backdrop-blur-md text-base min-w-[200px] text-center"
          >
            See more builds in the gallery
          </a>
          <a
            href="/articles"
            className="px-6 py-3 rounded-lg bg-black/70 border border-gray-700 text-gray-200 font-semibold shadow hover:bg-gray-800 hover:text-white transition backdrop-blur-md text-base min-w-[200px] text-center"
          >
            Read more articles
          </a>
          <a
            href="/soundtests"
            className="px-6 py-3 rounded-lg bg-black/70 border border-gray-700 text-gray-200 font-semibold shadow hover:bg-gray-800 hover:text-white transition backdrop-blur-md text-base min-w-[200px] text-center"
          >
            Listen to more sound tests
          </a>
        </div>
      </div>
    </div>
  </ArticleWrapper>
);

export default Brutal65V2;
